(() => {
  if (!customElements.get("grid-options")) {
    class t extends HTMLElement {
      constructor() {
        super(),
          (this.buttons = this.querySelectorAll("button")),
          (this.list = document.querySelector("[data-collection-list]")),
          (this.currentGrid = localStorage.getItem("viewSettings"));
      }
      connectedCallback() {
        this.buttons.forEach((t) => {
          this.currentGrid &&
            (t.dataset.grid === this.currentGrid
              ? t.setAttribute("disabled", "")
              : t.removeAttribute("disabled")),
            t.addEventListener("click", this.toggle.bind(this));
        }),
          document
            .querySelector("[data-collection-list]")
            .setAttribute("data-grid", this.currentGrid);
      }
      toggle(t) {
        let e = t.currentTarget.getAttribute("data-grid");
        this.buttons.forEach((t) => t.removeAttribute("disabled")),
          t.currentTarget.setAttribute("disabled", ""),
          this.list.setAttribute("data-grid", e),
          localStorage.setItem("viewSettings", e);
      }
    }
    customElements.define("grid-options", t);
  }
})();
